<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Overview</h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">Having a policies and procedures manual in place for an organization's development operations is critically important to managing donor resources in a consistent and transparent manner.</p>
            
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">To ensure staff adhere to the policies and procedures, it is highly recommended that you designate a specific team member who will be responsible for each of the operations in your manual and build accountability metrics into performance plans.</p>

            <p class="text-[14px] leading-[22px] mb-[0.5rem]">Your organization can choose to adopt the entire manual or select only those individual policies and procedures that best meet your departmental needs.</p>

            <p class="text-[14px] leading-[22px] mb-[0.5rem]">The gift agreement and pledge documents are intended to be sample documents. It is highly recommended that you consult your organization's attorney before utilizing these documents with donors.</p>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 